import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

const MastodonCallback: React.FC = () => {
  const { domain_name } = useParams();
  const code = new URLSearchParams(useLocation().search).get('code');
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!domain_name || !code) { setError(true); return; }
    fetch(`/api/v1/mastodon/callback/${domain_name}?code=${code}`)
      .then((r) => {
        if (!r.ok) throw new Error();
        navigate('/mypage');
      })
      .catch(() => setError(true));
  }, [domain_name, code, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-ink-600 dark:text-ink-300 bg-ink-50 dark:bg-ink-950">
      {error ? (
        <>
          <p className="text-rose-500 font-semibold">認証に失敗しました</p>
          <button
            onClick={() => navigate('/login')}
            className="underline text-sm"
          >
            ログインページへ戻る
          </button>
        </>
      ) : (
        <p className="animate-pulse">Mastodon で認証中…</p>
      )}
    </div>
  );
};

export default MastodonCallback;
